import { SettingsItemAutocomplete } from '@elipssolution/harfang';
import { Control, Controller } from 'react-hook-form';

import { DefaultFormType, AutocompleteFieldType } from '../../types/form';

type AutocompleteFormFieldProps<T> = {
	control: Control<DefaultFormType>;
	specificField: AutocompleteFieldType<T>;
};

const AutocompleteFormField = <T,>({
	control,
	specificField: { key, name, description, label, rules, getOptionLabel, dataSource, disableClearable },
}: AutocompleteFormFieldProps<T>) => {
	const { required, pattern } = rules || {};

	return (
		<Controller
			key={key}
			name={name}
			control={control}
			render={({ field: { value, ...field } }) => (
				<SettingsItemAutocomplete
					{...field}
					value={value as T}
					description={description}
					label={label}
					getOptionLabel={getOptionLabel}
					dataSource={dataSource}
					required={!!required}
					disableClearable={disableClearable}
				/>
			)}
			rules={{ required: !!required, pattern }}
		/>
	);
};

export default AutocompleteFormField;
